import { Component, OnInit } from '@angular/core';
import {SimpleModalComponent} from "ngx-simple-modal";
import {DateTime} from "luxon";
import {
  ExamEventResponse,
  ExaminersClient,
  ExamSubjectsClient,
  StudentResultsClient
} from "../../../generated-client/generated-api-client";
import {DateFormatter, DateFormatType} from "../../../utils/dateFormatter";
import { ExamEventModel } from './ExamEventModel';

export interface StudentEventsModal {
  studentId?: string;
}

@Component({
  selector: 'app-student-events-modal',
  templateUrl: './student-events-modal.component.html',
  styleUrls: ['./student-events-modal.component.sass']
})
export class StudentEventsModalComponent
  extends SimpleModalComponent<StudentEventsModal, boolean>
  implements StudentEventsModal {

  studentId!: string;
  isLoading = true;
  events?: ExamEventResponse[];
  examEvents = new Array<ExamEventModel>();

  constructor(private resultsClient: StudentResultsClient,
    private examinerClient: ExaminersClient,
    private examSubjectClient: ExamSubjectsClient) {
    super();
  }

  ngOnInit(): void {
    this.resultsClient.getAllEventsByStudent(this.studentId).subscribe(response => {
      this.isLoading = false;
      this.events = response;
      this.events.forEach(x =>
      {
        this.examEvents.push(new ExamEventModel(x, this.examinerClient, this.examSubjectClient))
      })
    })
  }

  dateToString(date: DateTime): string {
    return DateFormatter.format(date.toString(), DateFormatType.DateTime);
  }
}

